<template>
    <div class="mainpage">
        <div class="d-flex justify-content-between align-items-start step-bar">
            <div v-for="(step) in steps" :key="step.name" class="griditem">
                <div v-if="currentStep >= step.value" class="single-step" role="button" @click="changeStep(step.value)">
                    <img class="mx-2" :src="step.activeimage"/>
                    <div class="">
                        <p class="mb-0 step-num-active">STEP {{step.value}}</p>
                        <p class="mb-0 step-name-active"> {{step.name}} </p>
                    </div>
                </div>
                <div v-else class="single-step">
                    <img class="mx-2" :src="step.inactive"/>
                    <div class="">
                        <p class="mb-0 step-num">STEP {{step.value}}</p>
                        <p class="mb-0 step-name"> {{step.name}} </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="input-fields" v-if="currentStep === 1">
            <label class="mb-1" for="static-url">Enter custom domain</label>
            <InputText @keyup="check" type="text" v-model="domain" :placeholder="defaultDomain" />
            <span  v-if="errorMessage" class="validation-error">{{ errorMessage }}</span>
        </div>
        <div v-if="currentStep === 2">
            <p class="step-name-active">Point domain to below ip address as A record</p>
            <div v-for="(ip) in ipaddress" :key="ip" class="d-flex flex-column mb-2">
                <div class="d-flex align-items-center mb-3">
                    <InputText disabled class="ip-box" type="text" :placeholder="ip" />
                    <Button severity="secondary" v-tooltip.focus="'Copied!'" size="large" text rounded class="mx-1" icon="pi pi-copy" @click="copy(ip)" />
                </div>
            </div>
            <div class="d-flex align-items-center mb-4">
                <p class="m-0 step-name-active">Upload SSL Certificate</p>
                <input
                    type="file"
                    name="file"
                    id="ssl-cert"
                    class="inputfile-align"
                    @change="filechange"
                    style="display: none;cursor: pointer"
                />
                <label for="ssl-cert"><i class=" mx-3 pi pi-upload cursor-pointer" /></label>
                <p class="m-0" v-if="certFileName"> {{certFileName}} </p>
            </div>
            <div class="mb-4">
                <div class="d-flex align-items-center">
                    <p class="m-0 step-name-active">Upload certificate key</p>
                    <input
                        type="file"
                        name="file"
                        id="ssl-key"
                        class="inputfile-align"
                        @change="filechange"
                        style="display: none;cursor: pointer"
                    />
                    <label for="ssl-key"><i class=" mx-3 pi pi-upload cursor-pointer" /></label>
                    <p class="m-0" v-if="keyFileName"> {{keyFileName}} </p>
                </div>
            </div>
        </div>
        <div v-if="currentStep === 3">
            <p class="step-name-active">Once the DNR record is configured, please click here to verify the custom domain addition.</p>
        </div>
        <div class="actions-btns">
            <div class="gap">
                <Button class="mr-3" :label="currentStep === 3 ? 'Verify' : 'Next'" @click="next"/>
            </div>
            <div>
                <Button label="Cancel" severity="secondary" @click="cancel"/>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapModels } from '@/utils'
import toastr from 'toastr'
import config from '@/config/config'

export default {
    name: 'CreateDomain',
    components: {
    },
    data () {
        return {
            domain: '',
            currentStep: 1,
            steps: [
                { name: 'Add Custom Domain', value: 1, activeimage: this.$images.domains.domain_active, inactive: this.$images.domains.domain_inactive },
                { name: 'Configure Dns records', value: 2, activeimage: this.$images.domains.dns_active, inactive: this.$images.domains.dns_inactive },
                { name: 'Verify', value: 3, activeimage: this.$images.domains.verify_active, inactive: this.$images.domains.verify_inactive }
            ],
            keyFileName: '',
            certFileName: '',
            errorMessage: '',
            fileIds: [],
            filesData: [],
            ipaddress: [ config.DEFAULT_DOMAIN_PUBLIC_IP ],
            defaultDomain: config.DEFAULT_DOMAIN
        }
    },
    methods: {
        async changeStep (val) {
            this.currentStep = val
        },
        unsecuredCopyToClipboard (text) {
            const textArea = document.createElement('textarea')
            textArea.value = text
            document.body.appendChild(textArea)
            textArea.focus()
            textArea.select()
            try {
                document.execCommand('copy')
            } catch (err) {
            }
            document.body.removeChild(textArea)
        },
        async copy (ip) {
            if (navigator.clipboard) {
                await navigator.clipboard.writeText(ip)
            } else {
                this.unsecuredCopyToClipboard(ip)
            }
        },
        async next () {
            if (this.currentStep === 1) {
                if (this.domain) {
                    this.errorMessage = ''
                    this.currentStep++
                } else {
                    this.errorMessage = 'Please enter a domain name'
                }
            } else if (this.currentStep === 2) {
                if (this.keyFileName && this.certFileName) {
                    this.currentStep++
                } else {
                    if (!this.keyFileName) {
                        toastr.error('Please upload key file', 'Validation error')
                    }
                    if (!this.certFileName) {
                        toastr.error('Please upload certificate file', 'Validation error')
                    }
                }
            } else {
                const data = {
                    domain: this.domain,
                    ipaddress: this.ipaddress,
                    filesId: this.fileIds,
                    filesData: this.filesData
                }
                this.globalLoader = true
                const resp = await this.$store.dispatch('Domains/Domain/addDomain', data)
                if (resp) {
                    this.$router.push('/domain')
                }
                this.globalLoader = false
            }
        },
        check () {
            if (this.domain) {
                this.errorMessage = ''
            } else {
                this.errorMessage = 'Please enter a domain name'
            }
        },
        async filechange (event) {
            const file = event.target.files[0]
            const name = event.target.files[0].name
            if (event.target.id === 'ssl-cert') {
                if (name.endsWith('.crt') || name.endsWith('.pem')) {
                    this.certFileName = name
                } else {
                    toastr.error('Please upload .crt or .pem files for certificate', 'Upload')
                    return
                }
            }
            if (event.target.id === 'ssl-key') {
                if (name.endsWith('.key') || name.endsWith('.pem')) {
                    this.keyFileName = name
                } else {
                    toastr.error('Please upload .key or .pem files for certificate', 'Upload')
                    return
                }
            }
            let data = new FormData()
            data.append('file', file)
            data.append('name', name)
            const fileResponse = await this.$store.dispatch('Domains/Domain/uploadCertificate', data)
            if (fileResponse) {
                this.fileIds.push(fileResponse.id)
                this.filesData.push({
                    id: fileResponse.id,
                    filename: fileResponse.filename,
                    uniqueName: fileResponse.uniqueName,
                    path: fileResponse.path
                })
            }
        },
        async cancel () {
            this.$router.push('/domain')
        }
    },
    computed: {
        ...mapModels('general', ['globalLoader']),
        ...mapGetters({ currentUser: 'currentUser' })
    },
    mounted () {
    }
}
</script>

<style>
.step-bar{
    border-top: 1px solid rgba(233, 230, 228, 1);
    border-bottom: 1px solid rgba(233, 230, 228, 1);
    margin-bottom: 2rem;
}
.step-num-active {
    color: #2F3043;
    font-weight: 700;
}
.step-num {
    color: #2F3043;
    opacity: 50%;
    font-weight: 700;
}
.step-name-active {
    color: #2F3043;
    font-weight: 700;
}
.step-name {
    color: #2F3043;
    opacity: 50%;
    font-weight: 700;
}
.single-step {
    display: flex;
    align-items: center;
    padding: 0.5rem;
}
.ip-box {
    width: 200px;
}
</style>
